import { appFeatures } from "./AppFeatures";
import CloudLogger from "./Logging/CloudLogger";
import LocalLogger from "./Logging/LocalLogger";
import { ILogger } from "./Logging/Logger";
import SharedUtils from "./SharedUtils";

// TODO :: maybe refactor this tp use a factory pattern
let _actualLogger: ILogger = new LocalLogger();
export function initializeLogger(isProduction: boolean) {
	if (appFeatures.enableCloudLogging) {
		_actualLogger = new CloudLogger();
	}
}

const errorOnceMap: { [key: string]: boolean } = {};
export function logErrorOnce(...msgs: any[]): void {
	const key = msgs.join();
	if (!errorOnceMap[key]) {
		errorOnceMap[key] = true;
		logError(...msgs);
	}
}

export function logFatalAndExit(...msgs: any[]): void {
	_actualLogger.logCritical(...msgs);
	process.exit(1);
}

export function logCritical(...msgs: any[]): void {
	_actualLogger.logCritical(...msgs);
}
export function logErrorNoStack(...msgs: any[]): void {
	_actualLogger.logErrorNoStack(...msgs);
}

export function logWarningNoStack(...msgs: any[]): void {
	_actualLogger.logWarningNoStack(...msgs);
}

export function logError(...msgs: any[]): void {
	if (typeof location !== "undefined") {
		logErrorNoStack(...msgs);
		return;
	}
	if (msgs.length > 0 && msgs[0] instanceof Error) {
		const error = msgs[0] as Error;
		_actualLogger.logJSError(error);
	} else {
		_actualLogger.logError(...msgs);
	}
}

export function logWarning(...msgs: any[]): void {
	if (typeof location !== "undefined") {
		logWarningNoStack(...msgs);
		return;
	}
	_actualLogger.logWarning(...msgs);
}

export function logInfo(...msgs: any[]): void {
	_actualLogger.logInfo(...msgs);
}

const debugOnceMap: { [key: string]: boolean } = {};
export function logDebugOnce(...msgs: any[]): void {
	const key = msgs.join();
	if (!debugOnceMap[key]) {
		debugOnceMap[key] = true;
		logDebug(...msgs);
	}
}
export function logDebug(...msgs: any[]): void {
	_actualLogger.logDebug(
		...msgs.map((msg) => {
			try {
				return SharedUtils.clone(msg ?? "");
			} catch (e) {
				return msg;
			}
		})
	);
}
export function logDebugC(...msgs: any[]): void {
	logDebug(...msgs.map((msg) => JSON.parse(JSON.stringify(msg))));
}
